import { UsePointToProjectionResult } from '@/utils/map/usePointToProjection';
import { Feature } from 'ol';
import { CommentWithPinType } from '@/types/comment';
import { getPinFeature } from '@/components/Map/MapViewer/utils/config/pinsLayer/getPinFeature';
import { PinType } from '@/types/pin';
import { PINS_COLORS, TEXT_COLOR } from '@/constants/canvas';
import { ONE } from '@/constants/common';
import { getCommentPinStyle } from '@/components/Map/MapViewer/utils/config/pinsLayer/getCommentPinStyle';

export const getCommentFeature = (
  comment: CommentWithPinType,
  {
    pointToProjection,
    type,
    value,
  }: {
    pointToProjection: UsePointToProjectionResult;
    type: PinType;
    value: number;
  },
): Feature => {
  const color = PINS_COLORS[type];

  const textColor = TEXT_COLOR;

  const feature = getPinFeature(
    {
      x: comment.coordinates.x,
      height: 0,
      id: comment.id,
      width: 0,
      y: comment.coordinates.y,
    },
    pointToProjection,
    type,
  );
  const style = getCommentPinStyle({
    color,
    value,
    textColor,
  });

  feature.setStyle(style);
  return feature;
};

export const getCommentsFeatures = (
  comments: CommentWithPinType[],
  {
    pointToProjection,
  }: {
    pointToProjection: UsePointToProjectionResult;
  },
): Feature[] => {
  return comments.map((comment, index) =>
    getCommentFeature(comment, { pointToProjection, type: comment.pinType, value: index + ONE }),
  );
};
